import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { IPost } from '../../core/models/post';
import { IWall } from '../../core/models/wall';
import StackGrid, { transitions } from 'react-stack-grid';
import PostCard from '../post';
// import { Button } from '@material-ui/core';
import {Dispatch} from 'redux';
import { REQUEST_POSTS } from '../../core/handlers.actions';
import InfiniteScroll from 'react-infinite-scroll-component';

const { scaleDown } = transitions;

interface Props {
    wall: IWall;
    posts: [IPost];
    postsMetadata:any;
    eventName: string | boolean;
    getMorePosts: (data:any) => void;
}

interface State {
    addEditPost: boolean;
}

export class BrickLayout extends Component<Props, State>{
    grid: any = createRef();
    state: State = { addEditPost: false};

    constructor(props:Props){
        super(props);
        this.reOrderPosts = this.reOrderPosts.bind(this);
        this.loadMorePosts = this.loadMorePosts.bind(this);
    }

    public loadMorePosts(){
        const {postsMetadata, wall, getMorePosts} = this.props;
        const excludedIds = wall.featuredPosts.map((item:any) => item.id);
        const data = {tags: wall.feedTags, page: postsMetadata.nextPage, per_page: postsMetadata.limit, excluded: excludedIds, v: 1};
        if(wall.hasOwnProperty('feedTagsRef') && wall.feedTagsRef.length > 0) {data.tags = wall.feedTagsRef.map((tag:any) => tag._id); data.v = 2;}
        getMorePosts(data);
    }

    public reOrderPosts(list: any, featuredList:any, index:number):any {                                 
        if(featuredList.length === index) return list;
        const item = featuredList[index];                
        const startIndex = list.findIndex((post:any) => post._id === item.id);            
        if(startIndex === -1 || item.position === null) return this.reOrderPosts(list, featuredList, index + 1);        
        const [removed] = list.splice(startIndex, 1); // Remove from original position
        const endIndex = item.position;        
        list.splice(endIndex, 0, removed); // Place it in new position        
        return this.reOrderPosts(list, featuredList, index + 1);
    }

    public render() {
        const { posts, wall, postsMetadata, eventName} = this.props;
        const postList = (wall.featuredPosts.length > 0 && posts.length > 0) ? this.reOrderPosts(posts, wall.featuredPosts, 0): posts;  // there are featured re order     
            
        return (
            <div id="grid-scroll-target">                          
                <InfiniteScroll  dataLength={postList.length} next={this.loadMorePosts} hasMore={postsMetadata.hasNextPage} loader={<h4>Loading...</h4>}>
                <StackGrid
                    appear={scaleDown.appear}
                    appeared={scaleDown.appeared}
                    enter={scaleDown.enter}
                    entered={scaleDown.entered}
                    gridRef={(grid: any) => this.grid = grid}
                    columnWidth={250}
                    gutterWidth={20}
                    gutterHeight={20}
                    className="grid-holder">                          
                        {postList ? postList.map((post: IPost, key: number) => (wall.postRequiresApproval && !post.isApproved) ? null: <PostCard  post={post} key={key} layout={this.grid} eventName={eventName}/>) : null}                            
                </StackGrid>
                </InfiniteScroll>  
            </div>
            
        );
    }
}

const props = (app: any) => ({ wall: app.rootReducer.wall, posts: app.rootReducer.posts, postsMetadata: app.rootReducer.postsMetadata});
const mapDispatch = (dispatch:Dispatch) => ({
    getMorePosts: (data:any) => dispatch({type:REQUEST_POSTS, payload: data})
});
export default connect(props, mapDispatch)(BrickLayout);